<template>
  <div class="block-spinner" v-if="mainSpinner">
    <img
      class="spinner"
      :class="{ 'spninner-small': $vuetify.breakpoint.smAndDown}"
      src="../../assets/images/loading.gif"
      alt
    />
  </div>
</template>

<script>
export default {
  computed: {
    mainSpinner () {
      return this.$root.spinners.main
    }
  },
  watch: {
    'mainSpinner': function (x, y) {
      if (x) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.block-spinner {
  position: absolute;
  top:0;
  left: 0;
  background: rgba(168, 168, 168, 0.5);
  z-index: 99999;
  height: 100vh;
  width: 100vw;
}
.spinner {
  position: absolute;
  top: 45%;
  left: 50%;
  height: 65px;
  width: 65px;
}

.spninner-small {
  top: 48%;
  left: 46%;
  height: 50px;
  width: 50px;
}
</style>
